import { useSyncExternalStore } from "react";
import { useClient } from "./provider";

/** Unsaved note and task edits across all panes, including editors that have closed. */
export function useLocalSaveState(): "saved" | "saving" | "error" {
  const { autosave, taskAutosave } = useClient();
  const notes = useSyncExternalStore(
    autosave.subscribeAll,
    autosave.getOverallState,
    autosave.getOverallState,
  );
  const tasks = useSyncExternalStore(
    taskAutosave.subscribeAll,
    taskAutosave.getOverallState,
    taskAutosave.getOverallState,
  );
  if (notes === "error" || tasks === "error") return "error";
  if (notes === "dirty" || notes === "saving" || tasks === "dirty" || tasks === "saving")
    return "saving";
  return "saved";
}
